/* eslint-disable import/prefer-default-export */
import { createContext } from 'react';

const BasestationConnectionContext = createContext({});
export default BasestationConnectionContext;
